import React, { useState } from 'react'
import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react'
interface AccordionItemProps {
  title: string
  content: string
  isOpen: boolean
  toggleAccordion: () => void
}
const AccordionItem = ({
    title,
    content,
    isOpen,
    toggleAccordion,
  }: AccordionItemProps) => {
    return (
      <div className="border-t border-[#2f2f2f] first:rounded-t-xl last:rounded-b-xl overflow-hidden bg-[#1a1a1a]">
        <button
  onClick={toggleAccordion}
  className="w-full flex justify-between items-center px-6 py-4 text-left group bg-[#1a1a1a] hover:bg-[#222] text-white"
>

          <span className="text-white font-semibold text-base">{title}</span>
          <ChevronDownIcon
            className={`w-4 h-4 text-[#E94B35] transition-transform duration-300 ${
              isOpen ? 'rotate-180' : ''
            }`}
          />
        </button>
  
        <div
          className={`text-sm text-gray-300 px-6 overflow-hidden transition-all duration-300 ${
            isOpen ? 'max-h-96 pb-4' : 'max-h-0'
          }`}
        >
          {content}
        </div>
      </div>
    )
  }
  
interface AccordionProps {
  items: {
    title: string
    content: string
  }[]
}
export const Accordion: React.FC<AccordionProps> = ({ items }) => {
  const [openIndices, setOpenIndices] = useState<number[]>([])
  const toggleAccordion = (index: number) => {
    setOpenIndices((prevIndices) =>
      prevIndices.includes(index)
        ? prevIndices.filter((i) => i !== index)
        : [...prevIndices, index],
    )
  }
  return (
    <div className="bg-[#1a1a1a] rounded-xl overflow-hidden">
      {items.map((item, index) => (
        <AccordionItem
          key={index}
          title={item.title}
          content={item.content}
          isOpen={openIndices.includes(index)}
          toggleAccordion={() => toggleAccordion(index)}
        />
      ))}
    </div>
  )
}